'use strict';
angular.module('cvsApp').factory('itemCartModel', ['cvsAppData', function(CAD) {

    var itemCartModel = function() {

        var self = this;

        var isPznRefill = CAD.isPznRefill();

        var cartItems = [];
        var checkOutData = {};
        var jachoData = {};
        var clinicalQuestions = {};
        var reffilPrescription = [];
        var getAncillaryRx = [];
        var getrefillEligibleAncillaryRx = [];
        var patientInfo = {};
        var smartGrouper = {};
        var activePaymentInfo = null;
        var hasPartialRefillRx = false;
        /**
         * SP 11/13/2016 - ITPR015400 - Guest Refill
         * Added guestRxItem to track guest Rx from /GR route
         */
        var guestRxItem = {};
        /**
         * SP 11/23/2016 - ITPR015400 - Guest Refill
         * Added guestRxEnquiry to track guest Rx enquiry from /GR route
         */
        var guestRxEnquiry = {};

        var sessionArray = [];
        if (cvsUtility.queryMap.FromQuickRegistration && cvsUtility.queryMap.FromQuickRegistration.toLowerCase() == 'yes') {
            sessionStorage.sessionArray ? JSON.parse(sessionStorage.sessionArray) : [];
        }

        this.setPatientInfo = function(data) {
            patientInfo = data;
        }

        this.getPatientInfo = function() {
            return patientInfo;
        }

        this.emptyCart = function() {
            cartItems = [];
            //if(isPznRefill){
            sessionArray = [];
            sessionStorage.setItem("sessionArray", JSON.stringify(sessionArray));
            sessionStorage.setItem("selectAll", null);
            hasPartialRefillRx = false;
            smartGrouper = new Array();
            //}

            return cartItems;
        }

        this.setPrescription = function(data) {
            reffilPrescription = data;
        }

        this.getPrescription = function() {
            return reffilPrescription;
        }

        this.setAncillary = function (data) {
            getAncillaryRx = data;
        }
        this.getAncillary = function () {
            return getAncillaryRx;
        }
        this.setrefillEligibleAncillary = function (data) {
            getrefillEligibleAncillaryRx = data;
        }
        this.getrefillEligibleAncillary = function () {
            return getrefillEligibleAncillaryRx;
        }
        /**
         * SP 11/13/2016 - ITPR015400 - Guest Refill
         * Modified sessionArray to track encrypted Rx number.
         */
        this.insertCartItem = function(item) {
            this.deleteCartItem(item);
            if(item.refillsRemaining < 1){
                hasPartialRefillRx = true;
            }
            cartItems.push(item);
            sessionArray.push({
                "rxNumber": item.rxNumber,
                "rxNumberEnc": item.rxNumberEnc,
                "rxNumberHash": item.rxNumberHash
            });
            sessionStorage.setItem("sessionArray", JSON.stringify(sessionArray));
        }

        this.insertCartSupply = function (item) {
            this.deleteCartItem(item);
            if (item.refillsRemaining < 1) {
                hasPartialRefillRx = true;
            }
            var supply = item.suppliesGrouped;
            var supplies = [];
            for (var i = 0; i < supply.length; i++) {
                (function (i) {
                    supplies.push({
                        "rxNumber": supply[i].rxNumber,
                        "rxNumberEnc": supply[i].rxNumberEnc,
                        "rxNumberHash": supply[i].rxNumberHash
                    });
                })(i);
            }
            cartItems.push(item);
            sessionArray.push({
                "rxNumber": item.rxNumber,
                "rxNumberEnc": item.rxNumberEnc,
                "rxNumberHash": item.rxNumberHash,
                "Supplies": supplies
            });
            sessionStorage.setItem("sessionArray", JSON.stringify(sessionArray));
        }

        this.insertSelectAll = function(selectAll, clearRxDetails) {
            sessionStorage.setItem("selectAll", selectAll);
            sessionStorage.setItem("clearRxDetails", clearRxDetails);
        }

        this.deleteCartItem = function(rxInfo) {
            //deleteFromQuestion5(rxInfo);

            sessionArray = _.reject(sessionArray, function(item) {
                if (item && item.rxNumberHash === rxInfo.rxNumberHash) {
                    return item;
                }
            });
            sessionStorage.setItem("sessionArray", JSON.stringify(sessionArray));

            cartItems = _.reject(cartItems, function(item) {
                if (item && item.rxNumberHash === rxInfo.rxNumberHash) {
                    return item;
                }
            });
            hasPartialRefillRx = false;
            _.each(cartItems, function(item){
                if(item.refillsRemaining < 1){
                    hasPartialRefillRx = true;
                }
            });
            return cartItems;
        }
        this.deleteCartSupply = function (rxInfo) {
            for (var i = 0; i < sessionArray.length; i++) {
                if (sessionArray[i].hasOwnProperty('Supplies')) {
                    for (var j = 0; j < sessionArray[i].Supplies.length; j--) {
                        if (sessionArray[i].rxNumberHash === rxInfo.rxNumberHash) {
                            sessionArray[i].Supplies.splice(0, 1);
                            if (sessionArray[i].Supplies.length == 0) {
                                delete sessionArray[i].Supplies;
                                break;
                            }
                        } else {
                            break;
                        }

                    }
                }
            }
            sessionArray = _.reject(sessionArray, function (item) {
                if (item && item.rxNumberHash === rxInfo.rxNumberHash) {
                    return item;
                }
            });
            sessionStorage.setItem("sessionArray", JSON.stringify(sessionArray));
            for (var i = 0; i < cartItems.length; i++) {
                if (cartItems[i].hasOwnProperty('suppliesGrouped')) {
                    for (var j = 0; j < cartItems[i].suppliesGrouped.length; j--) {
                        if (cartItems[i].rxNumberHash === rxInfo.rxNumberHash) {
                            cartItems[i].suppliesGrouped.splice(0, 1);
                            if (cartItems[i].suppliesGrouped.length == 0) {
                                delete cartItems[i].suppliesGrouped;
                                break;
                            }
                        } else {
                            break;
                        }
                    }
                }
            }
            cartItems = _.reject(cartItems, function (item) {
                if (item && item.rxNumberHash === rxInfo.rxNumberHash) {
                    return item;
                }
            });
            hasPartialRefillRx = false;
            _.each(cartItems, function (item) {
                if (item.refillsRemaining < 1) {
                    hasPartialRefillRx = true;
                }
            });
            return cartItems;
        }
        this.setCartItems = function() {
            cartItems = [];
        }

        this.getCartItems = function() {
            return cartItems;
        }

        this.getCartItemsInfo = function() {
            var cartItemInfo = {
                isCats: false,
                isHbs: false,
                ancillaryForAll: true,
                qVisibilityFlag: "",
                clinicalQuestionStart: 0,
                itemLength: cartItems.length,
            }
			// console.log("cartItems", cartItems);
            for (var i = 0; i < cartItems.length; i++) {
                if (cartItems[i].prescriptionSystemName.indexOf('CATS') >= 0) {
                    cartItemInfo.isCats = true;
                } else if (cartItems[i].prescriptionSystemName.indexOf('HBS') >= 0) {
                    cartItemInfo.isHbs = true;
                }

                //If even one prescription in the cart has the ancillary indicator as false
                //show question 3-6. This indicator will be true only if none of the rx
                //has indicator as false
                if (cartItems[i].ancillaryProductInd === "false") {
                    cartItemInfo.ancillaryForAll = false;
                }

                if (cartItems[i].prescriptionSystemName.indexOf('CATS') >= 0 || cartItems[i].ancillaryProductInd === "false") {
                    cartItems[i].showQues3To6 = true;
                } else {
                    cartItems[i].showQues3To6 = false;
                }
            }

            cartItemInfo.qVisibilityFlag = (cartItemInfo.isHbs ? "T" : "F") + (cartItemInfo.isCats ? "T" : "F") + (cartItemInfo.ancillaryForAll ? "T" : "F");

            cartItemInfo.isSignatureRequiredFlag = (cartItemInfo.isHbs ? "T" : "F") + (cartItemInfo.isCats ? "T" : "F") + (checkOutData["signatureRequiredForDelivery"] ? "T" : "F")

            cartItemInfo.clinicalQuestionStart = 0;
            if (cartItemInfo.qVisibilityFlag === "TFT") {
                cartItemInfo.clinicalQuestionStart = 3;
            } else {
                cartItemInfo.clinicalQuestionStart = 7;
            }
            if(patientInfo && patientInfo.hasOwnProperty("getPatientInfo") && patientInfo.getPatientInfo() && patientInfo.getPatientInfo().medicareIndicator === 'Y' ){
            cartItemInfo.clinicalQuestionStart++;
            }
            return cartItemInfo;
        }

        this.setSmartGrouper = function (data) {
            smartGrouper = data;
        }

        this.getSmartGrouper = function () {
            return smartGrouper;
        }

        this.addCheckOutInfo = function(info, val) {
            checkOutData[info] = val;
        }
        this.emptyCheckOutData = function() {
            checkOutData = {};
            return checkOutData;
        }

        this.checkOutInfo = function(key) {
            return checkOutData[key];
        }

        this.allCheckOutInfo = function() {
            return checkOutData;
        }

        this.emptyQuestions = function() {
            jachoData = {};
            return jachoData;
        }

        this.emptyClinicalQuestions = function() {
            clinicalQuestions = {};
            return clinicalQuestions;
        }

        this.setQuestions = function(data) {
            jachoData = data;
        }

        this.setClinicalQuestions = function(data) {
            clinicalQuestions = data;
        }

        var deleteFromQuestion5 = function(rxInfo) {
            jachoData[4] = _.reject(jachoData[4], function(question) {
                if (question && question.rxNumberHash === rxInfo.rxNumberHash) {
                    return question;
                }
            });
            return jachoData;
        }


        this.getQuestions = function() {
            return jachoData;
        }
        this.getClinicalQuestions = function() {
            return clinicalQuestions;
        }

        this.yesCounter = function() {
            var len = jachoData.length;
            var counter = 0;
            for (var i = 0; i < len; i++) {
                if (jachoData[i] && jachoData[i].answer == "yes") {
                    counter++;
                }
            }
            return counter;
        }
        /**
         * SP 11/13/2016 - ITPR015400 - Guest Refill
         * Added guestRxItem to track guest Rx from /GR route
         */
        this.setGuestRxItem = function(item) {
            guestRxItem = item;
        }

        this.getGuestRxItem = function() {
            return guestRxItem;
        }
        /**
         * SP 11/23/2016 - ITPR015400 - Guest Refill
         * Added guestRxEnquiry to track guest Rx Enquiry details from /GR route
         */
        this.setGuestRxEnquiry = function(item) {
            guestRxEnquiry = item;
        }

        this.getGuestRxEnquiry = function() {
            return guestRxEnquiry;
        }

        this.setActivePaymentInfo = function(paymentInfo){
            activePaymentInfo = paymentInfo;
        }

        this.getActivePaymentInfo = function(){
            return activePaymentInfo;
        }

        this.getHasPartialRefillRx = function(){
            return hasPartialRefillRx;
        }

        this.updateShippingDate = function(groupIndex, deliveryDate){
                //loop through this smartGrouper array  Find that groupIndex and assign the deliveryDate
                for(var index = 0; index < smartGrouper.length; index++){
                    if(smartGrouper[index].groupIndex === groupIndex){
                        smartGrouper[index]['deliveryDate'] = deliveryDate
                    }
                }
        }


    }

    return new itemCartModel();
}]);
